export const RBE24230_OUTPUT_MASKS = [0b00000001, 0b00000010, 0b00000100, 0b00001000];
export const RBE24230_DEFAULT_OUTPUTS_STATUS = [false, false, false, false];

export const RBE24230_INPUT_MASKS = [0b00000001, 0b00000010, 0b00000100, 0b00001000];
export const RBE24230_DEFAULT_INPUT_STATUS = [false, false, false, false];


export const RBE_24_COMMAND_ID_AUTOMATION_1 = [256, 257, 258, 259, 10005];
export const RBE_24_COMMAND_ID_AUTOMATION_2 = [260, 261, 262, 263, 10021];
export const RBE_24_COMMAND_ID_AUTOMATION_3 = [264, 265, 266, 267, 10037];
export const RBE_24_COMMAND_ID_AUTOMATION_4 = [268, 269, 270, 271, 10053];